var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15H4.21875L3.96875 16H0V1H1V0H2V1H4V0H5V1H7V0H8V1H10V0H11V1H12V6.0625C11.8229 6.08854 11.6484 6.13281 11.4766 6.19531C11.3099 6.25781 11.151 6.33854 11 6.4375V2H1V15ZM12.4375 7C12.6562 7 12.8594 7.03906 13.0469 7.11719C13.2396 7.19531 13.4062 7.30469 13.5469 7.44531C13.6875 7.58073 13.7969 7.74479 13.875 7.9375C13.9583 8.125 14 8.32812 14 8.54688C14 8.75 13.9609 8.94792 13.8828 9.14062C13.8047 9.33333 13.6927 9.5026 13.5469 9.64844L7.94531 15.25L5 15.9844L5.73438 13.0391L11.3359 7.44531C11.487 7.29427 11.6562 7.18229 11.8438 7.10938C12.0312 7.03646 12.2292 7 12.4375 7ZM12.8359 8.94531C12.9453 8.83594 13 8.70312 13 8.54688C13 8.38542 12.9453 8.25521 12.8359 8.15625C12.7318 8.05208 12.599 8 12.4375 8C12.3646 8 12.2943 8.01302 12.2266 8.03906C12.1589 8.0599 12.099 8.09635 12.0469 8.14844L6.64062 13.5547L6.375 14.6094L7.42969 14.3438L12.8359 8.94531Z",
    fill: "#205493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ffae2d5df125d426e048a0b8387b63cb.svg";
export { ForwardRef as ReactComponent };